import { render, staticRenderFns } from "./PepperScene.vue?vue&type=template&id=cc5dbdaa&"
import script from "./PepperScene.vue?vue&type=script&lang=js&"
export * from "./PepperScene.vue?vue&type=script&lang=js&"
import style0 from "./PepperScene.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports